import React from "react";
import classnames from "classnames/bind";
import { Link } from "react-router-dom";

import css from "./Footer.scss";

const cx = classnames.bind(css);
const moduleName = "Footer";

const Footer = () => (
  <footer className={cx(moduleName)}>
    <div className={cx(`${moduleName}-inner`)}>
      <div className={cx(`${moduleName}-col`, `${moduleName}-col--brand`)}>
        <p className={cx(`${moduleName}-brand`)}>스테이 무릉도원</p>
        <p className={cx(`${moduleName}-tagline`)}>
          자연과 함께하는 힐링 스테이
        </p>
      </div>

      <div className={cx(`${moduleName}-col`)}>
        <p className={cx(`${moduleName}-col-title`)}>Contact</p>
        <p><a href="tel:01047386659">010-4738-6659</a></p>
        <p><a href="tel:03337326658">033-372-6658</a></p>
        <p className={cx(`${moduleName}-address`)}>강원도 영월군 중방길 2</p>
      </div>

      <div className={cx(`${moduleName}-col`)}>
        <p className={cx(`${moduleName}-col-title`)}>Quick Links</p>
        <p><Link to="/room">객실 소개</Link></p>
        <p><Link to="/surrounding">주변전경</Link></p>
        <p><Link to="/reservation">예약 안내</Link></p>
        <p><Link to="/direction">오시는 길</Link></p>
      </div>
    </div>

    <div className={cx(`${moduleName}-bottom`)}>
      <p>© {new Date().getFullYear()} 스테이 무릉도원. All rights reserved.</p>
    </div>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/App/pages/Home/components/Footer.js